const STEPS: { step: 1 | 2 | 3; label: string; description: string }[] = [
  { step: 1, label: 'Brief', description: 'Capture requirements' },
  { step: 2, label: 'Recommendation', description: 'Score and optimize' },
  { step: 3, label: 'Plan', description: 'Review and submit' },
]

function CheckIcon() {
  return (
    <svg viewBox="0 0 16 16" width="12" height="12" fill="none" aria-hidden>
      <path
        d="M3.5 8.5L6.5 11.5L12.5 4.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function StepIndicator({ step }: { step: 1 | 2 | 3 }) {
  return (
    <nav className="stepper" aria-label="Planning progress">
      {STEPS.map((s, index) => {
        const state = s.step < step ? 'done' : s.step === step ? 'current' : 'upcoming'
        return (
          <div className={`stepper-item ${state}`} key={s.step}>
            <div className="stepper-marker" aria-hidden>
              {state === 'done' ? <CheckIcon /> : s.step}
            </div>
            <div className="stepper-text">
              <span className="stepper-label">{s.label}</span>
              <span className="stepper-description">{s.description}</span>
            </div>
            {index < STEPS.length - 1 ? <div className="stepper-connector" aria-hidden /> : null}
          </div>
        )
      })}
    </nav>
  )
}
